<template>
  <div>
    <v-overlay :value="loading" :absolute="true" v-if="$route.name !== 'reportPrint'">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <LoadsReportTemplate v-if="$route.name === 'reportPrint'"
                            :entries="loads"
                            :totalsCounts="totalsCounts"
                            :from="from"
                            :to="to"
                            :key="'reportTemplateKey' + loads.length"
                            :companyId="companyId"
    />
    <v-card v-else>
      <v-card-title :style="{ backgroundColor: $root.currentTheme.background }">
        {{$t('Reports.Loads')}}
      </v-card-title>

      <LoadsTotals :totalsCounts="totalsCounts" v-if="totalsCounts"/>

      <ReportActions
        :key="reportsGroupsListKey"
        :userId="0"
        :from="from"
        :to="to"
        :paramsType="$route.params.type"
        :selectedItems="selectedItems"
        :isSelectedHaveNotPayed="isSelectedHaveNotPayed"
        :isSelectedHavePayed="isSelectedHavePayed"
        @create-report-group="createReport"
        @mark-selected-as-paid="markSelectedAsPaid"
        @mark-selected-as-not-paid="markSelectedAsNotPaid"
        @mark-selected-as-payed-and-create-report-group="markSelectedAsPayedAndCreateReportGroup"
        @show-saved-reports="$root.onShowReportsModal"
      />
      <v-layout>
        <v-flex shrink>
          <FiltersPanel
            ref="filtersPanel"
            prefix="driversShiftsReport"
            outlined
            :isExpansionPanel="$root.isMobile"
            :loading="loading"
            :items="filtersItems"
            :key="filtersKey"
            @filterBrokerKeyUp="filterBrokerSearch"
            @change="onFilterChanged"/>
        </v-flex>
        <v-flex>
          <v-text-field
            class="mt-1"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            single-line
            outlined dense
            hide-details
          />
        </v-flex>
        <v-flex shrink v-if="$root.isMobile">
          <v-btn class="mt-1 ml-1"
                  @click="$refs.filtersPanel.showFiltersDrawer()">
                  <v-icon>mdi-filter</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
        <!--<v-flex shrink class="text-right" v-if="$root.isFullFinancialDataAllowedToView">
          <v-btn class="ma-1" :disabled="selectedItems.length === 0" @click="createReportGroup(0, lastReportsGroupNumber + 1, $route.params.type, from, to)"><v-icon left>mdi-clipboard-check-outline</v-icon> {{$t('Reports.CreateReportsGroup')}}</v-btn>
        </v-flex>-->
      <!--<hr/>
      {{loads}}
      <hr/>-->
      <v-list v-if="$root.isMobile">
        <v-list-item-group
          v-model="selectedItems"
          multiple
          active-class=""
        >
          <template v-for="item in loads">
            <v-list-item :key="item.id" :value="item">
              <template v-slot:default="{ active }">
                <v-list-item-icon>
                  <v-checkbox :input-value="active"/>
                </v-list-item-icon>
                <v-list-item-content @click.stop="$root.onShowLoadPreview(item.id)">
                  <v-list-item-title>
                    <v-avatar style="cursor: pointer;"
                              class="mr-1"
                              :size="24"
                              @click.stop="$root.onShowUserPreview(item.dispatcher, item.dispatcherName)"
                              :color="(item.dispatcherInitials && !item.dispatcherAvatar)?'#015aaa':null">
                      <v-img :src="$root.getImageUrl('avatar', item.dispatcherAvatar)" v-if="item.dispatcherAvatar"></v-img>
                      <span class="white--text" v-else-if="item.dispatcherInitials">{{item.dispatcherInitials}}</span>
                      <v-icon large v-else>account_circle</v-icon>
                    </v-avatar>
                    <b>#{{item.id}}</b>
                    <v-chip small color="success" class="ml-1">{{$root.moneyValue(item.rate, 2)}}</v-chip>
                    <v-chip small class="ml-1">{{item.miles.toLocaleString()}}{{$t('milesShort')}}</v-chip>
                  </v-list-item-title>
                  <v-list-item-title>
                    {{item.pickupLocationName}}<br/>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{item.startedPST}}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{item.deliveryLocationName}}
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    {{item.endedPST}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip class="ma-1" small>
                    {{$t('Reports.RatePerMileShort')}}: <b>{{$root.moneyValue(item.rpm, 2)}}</b>
                    </v-chip>
                    <v-chip class="ma-1" small>
                    {{$t('Reports.ExpensesShort')}}: <b>{{$root.moneyValue(item.expenses, 2)}}</b>
                    </v-chip>
                    <v-chip class="ma-1" small>
                    {{$t('Reports.Net')}}: <b>{{$root.moneyValue(item.net, 2)}}</b>
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
            <v-divider :key="'div' + item.id"/>
          </template>
        </v-list-item-group>
      </v-list>
      <v-data-table
        v-else
        :headers="headers"
        :items="loads"
        :search="search"
        v-model="selectedItems"
        height="calc(100vh - 200px)"
        fixed-header
        show-select
        :items-per-page="100"
        :footer-props="footer_props"
        @item-selected="onItemSelected"
        @toggle-select-all="onItemSelected"
        @click:row="$root.onShowLoadPreview($event.id)"
      >
        <template v-slot:item.status="{ item }">
          <div class="text-no-wrap">
            <v-icon v-if="item.status.phaseIcon" v-html="item.status.phaseIcon" :color="item.status.phaseColor" class="mr-1"></v-icon>
            <v-icon v-if="item.status.stageIcon" small v-html="item.status.stageIcon" :color="item.status.stageColor" class="mr-1"></v-icon>
            <v-icon v-if="item.isReturnToHQ === 1" color="success" class="mr-1">mdi-redo-variant</v-icon>
          </div>
        </template>

        <template v-slot:item.started="{ item }">
          <div class="text-no-wrap">{{item.startedPST}}</div>
          <div class="text-no-wrap">{{item.endedPST}}</div>
        </template>

        <template v-slot:item.uid_load_number="{ item }">
            <span class="text-no-wrap">
              {{item.loadNumber}}
              <v-btn v-if="item.loadNumber" small icon @click.stop="$root.copyToClipboard(item.loadNumber)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
          <br/>
          <span class="text-no-wrap">
              {{item.uid}}
              <v-btn v-if="item.uid" small icon @click.stop="$root.copyToClipboard(item.uid)"><v-icon small>mdi-content-copy</v-icon></v-btn>
            </span>
        </template>
        <template v-slot:item.disp_broker="{ item }">
          <v-avatar style="cursor: pointer;"
                    class="mr-1"
                    :size="24"
                    @click.stop="$root.onShowUserPreview(item.dispatcher, item.dispatcherName)"
                    :color="(item.dispatcherInitials && !item.dispatcherAvatar)?'#015aaa':null">
            <v-img :src="$root.getImageUrl('avatar', item.dispatcherAvatar)" v-if="item.dispatcherAvatar"></v-img>
            <span class="white--text" v-else-if="item.dispatcherInitials">{{item.dispatcherInitials}}</span>
            <v-icon large v-else>account_circle</v-icon>
          </v-avatar>
          <a v-if="$root.isAccessRightAllowView($store.getters.menuRights['Dispatcher'])"
             @click.stop="$root.route('/user/page/' + item.dispatcher)">{{item.dispatcherName}}</a>
          <span v-else>{{item.dispatcherName}}</span>
          <br/>
          <a v-if="$root.isAccessRightAllowView($store.getters.menuRights['Broker'])"
             @click.stop="$root.route('/user/page/' + item.broker)">{{item.brokerName}}</a>
          <span v-else>{{item.brokerName}}</span>
        </template>

        <template v-slot:item.rate="{ item }">
          <template v-if="item.additionalPayments !== 0">
            <div style="white-space: nowrap;">
              {{parseFloat(item.Rate.toFixed(2)).toLocaleString()}}
              {{item.RTLRate ? '+'+parseFloat(item.RTLRate.toFixed(2)).toLocaleString() : ''}}
              {{item.additionalPayments > 0?'+':'-'}}{{parseFloat(item.additionalPayments.toFixed(2)).toLocaleString()}}=</div>
            <v-chip small :color="item.isLoadInvoiceNotMatch ? 'error' : item.invoiceId > 0 ? 'success' : null" style="white-space: nowrap;">
              <v-icon small class="mr-1">fa-dollar-sign</v-icon>{{getTotalRate(item)}}</v-chip>
          </template>
          <template v-else>
            <v-chip  small :color="item.isLoadInvoiceNotMatch ? 'error' : item.invoiceId > 0 ? 'success' : null" style="white-space: nowrap;">
              <v-icon small class="mr-1">fa-dollar-sign</v-icon>{{getTotalRate(item)}}</v-chip>
          </template>
        </template>

        <template v-slot:item.gross="{ item }">
          <div style="white-space: nowrap;"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(item.gross).toLocaleString()}}</div>
          <template v-if="item.finished === 2"><v-chip color="warning" small>TONU</v-chip></template>
        </template>

        <template v-slot:item.net="{ item }">
          <div style="white-space: nowrap;"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(item.net).toLocaleString()}}</div>
        </template>

        <template v-slot:item.expenses="{ item }">
          <div style="white-space: nowrap;"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(item.expenses).toLocaleString()}}</div>
        </template>

        <template v-slot:item.miles="{ item }">
          {{item.miles.toLocaleString()}} {{$t('milesShort')}}
        </template>
        <template v-slot:item.rpm="{ item }">
          ${{item.rpm.toFixed(2)}}
        </template>

        <template v-slot:item.drivers_trucks="{ item }">
          <TruckDriversSnippet :trucks="item.trucks" :isDriverOO="item.isDriverOwnerOperator === 1" :truckOO="item.truckOOData" :driverOO="item.driverOOData" :load-id="item.id"></TruckDriversSnippet>
        </template>

        <template v-slot:item.name="{ item }">
          <v-layout class="text-no-wrap">
            <v-flex shrink>
              <LoadLocationsTooltip :load-fields="item"/>
            </v-flex>
            <v-flex grow class="pl-2">
              <LoadLocationsStartEnd
                :load-name="item.pickupLocationName +'--' + item.deliveryLocationName"
                :max-width="'200px'"
                :gmapsDirectionsBtn="true"
                @open-gmaps-directions="() => { $root.openGmapsDirections(item) }"
                @show-map-modal="() => { $emit('show-map-modal', item) }"
                @show-map-div="(event) => { $emit('show-map-modal', item, true, event) }"
              />
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:item.factoring="{ item }">
          {{item.factoring}}%
        </template>

        <template v-slot:item.actions="{ item }">
          <v-layout>
            <v-flex class="pa-0" v-for="invoiceItem in item.invoicesArray" :key="'inv'+invoiceItem.id">
              <template v-if="invoiceItem.invoiceReceivedDate > 0 && $root.isInvoicesViewAllowed">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" :color="$root.getInvoiceTypeColorByStatus(invoiceItem.invoiceStatus)" @click.stop="$root.route('/invoices/page/'+invoiceItem.invoiceId)"><v-icon small>fa-file-invoice-dollar</v-icon></v-btn>
                  </template>
                  <span>{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;<strong>{{invoiceItem.invoiceStatus}}</strong></span>
                </v-tooltip>
              </template>
              <template v-else-if="!invoiceItem.invoiceReceivedDate && $root.isInvoicesViewAllowed">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" :color="invoiceItem.invoiceDueLeftSeconds < 0 ? 'red' : 'warning'" @click.stop="$root.route('/invoices/page/'+invoiceItem.invoiceId)"><v-icon small>fa-file-invoice-dollar</v-icon></v-btn>
                  </template>
                  <span v-if="invoiceItem.invoiceDueLeftSeconds < 0">{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;{{$t('Invoices.Overdue')}}:&nbsp;-{{Math.ceil($root.secondsToHms(invoiceItem.invoiceDueLeftSeconds).hours / 24)}} d.</span>
                  <span v-if="invoiceItem.invoiceDueLeftSeconds > 0">{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;{{$t('Invoices.DueDate')}}:&nbsp;+{{Math.ceil($root.secondsToHms(invoiceItem.invoiceDueLeftSeconds).hours / 24)}} d.</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex v-if="item.invoicesArray.length === 0">
              <v-btn icon small disabled><v-icon small class="mr-1">fa-file-invoice-dollar</v-icon></v-btn>
            </v-flex>
            <v-flex>
              <template v-if="item.bid">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" @click.stop="$root.route('/bids/'+item.bid)"><v-icon small class="mr-1">mdi-file-question</v-icon></v-btn>
                  </template>
                  <span>Bid #{{item.bid}}</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" @click.stop="onShowDocuments(item)">
                      <v-icon small class="mr-1" :color="item.isAllRequiredDocsUploaded ? 'success' : 'warning'">mdi-file-multiple</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="item.isAllRequiredDocsUploaded">{{$t('Loads.uploadDocuments')}}</span>
                  <span v-else>
                    <template v-for="(md, index) in item.missingDocs">
                      <span :key="'missingDocs_'+item.id+index" v-if="index === 'loadPhotos'">{{$t('Loads.LoadPhotos')}}:&nbsp; {{md ? $root.t('Yes') : $root.t('No')}}<br/></span>
                      <span :key="'missingDocs_'+item.id+index" v-if="index === 'rateCon'">{{$t('Loads.RateCon')}}:&nbsp; {{md ? $root.t('Yes') : $root.t('No')}}<br/></span>
                      <span :key="'missingDocs_'+item.id+index" v-if="index === 'do'">{{$t('Loads.DeliveryOrder')}}:&nbsp; {{md ? $root.t('Yes') : $root.t('No')}}<br/></span>
                      <span :key="'missingDocs_'+item.id+index" v-if="index === 'pod'">{{$t('Loads.POD')}}:&nbsp; {{md ? $root.t('Yes') : $root.t('No')}}<br/></span>
                      <span :key="'missingDocs_'+item.id+index" v-if="index === 'bol'">{{$t('Loads.BOL')}}:&nbsp; {{md ? $root.t('Yes') : $root.t('No')}}</span>
                    </template>
                  </span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small icon v-on="on" @click.stop="onShowExpenses(item.expensesJSON, item.finished, item.id, item.trucks)">
                      <v-icon small class="mr-1" :color="item.isPendingExpenses ? 'warning':'success'">fa-coins</v-icon>
                    </v-btn>
                  </template>
                  <span>{{!item.isPendingExpenses ? $t('Loads.ExpensesTitle') : $t('Loads.ExpensesHasPending')}}</span>
                </v-tooltip>
              </template>
            </v-flex>
          </v-layout>
        </template>
      </v-data-table>

      <!--<v-layout v-if="$root.isFullFinancialDataAllowedToView">
        <v-flex xs12 class="text-right">
          <v-btn class="ma-1" :disabled="selectedItems.length === 0" @click="createReportGroup(0, lastReportsGroupNumber + 1, $route.params.type, from, to)"><v-icon left>mdi-clipboard-check-outline</v-icon> {{$t('Reports.CreateReportsGroup')}}</v-btn>
        </v-flex>
      </v-layout>-->
    </v-card>

    <v-dialog v-model="expensesModal" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <h2>{{$t('Loads.ExpensesTitle')}}</h2><v-spacer></v-spacer><v-btn icon @click="expensesModal=false;"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <LoadExpenses :key="expensesModalKey"
                      :expensesArray="selectedExpenses"
                      :readOnly="!$root.isLoadsEditAllowed"
                      :isFinished="selectedFinishedField !== 0"
                      :loadId="selectedExpensesLoadId"
                      :preselectedTruck="selectedExpensesTruckId"
                      :preselectedDriver="selectedExpensesUserId"
                      @expensesSaved="fetchData()"
        ></LoadExpenses>
      </v-card>
    </v-dialog>
    <v-dialog v-model="documentsModal" scrollable>
      <v-card>
        <v-card-title>
          <h2>{{$t('Loads.uploadDocuments')}}</h2><v-spacer></v-spacer><v-btn icon @click="documentsModal=false;"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <LoadDocuments :key="documentsModalKey" :fields="selectedELoadFields" :readonly="true"></LoadDocuments>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import LoadExpenses from '../../components/LoadExpenses.vue';
import LoadDocuments from '../../components/LoadDocuments.vue';
import LoadsReportTemplate from '../../views/Reports/LoadsReportTemplate.vue';
import LoadLocationsTooltip from '../../components/LoadLocationsTooltip.vue';
import ReportActions from '../../components/ReportActions';
import TruckDriversSnippet from '../../components/TruckDriversSnippet.vue';
import LoadLocationsStartEnd from '../../components/LoadLocationsStartEnd.vue';
import LoadsTotals from './LoadsTotals';
import FiltersPanel from '../../components/FiltersPanel.vue';

export default {
  name: 'TrucksReport',
  props: ['from', 'to', 'selectedStr', 'companyId'],
  components: { LoadLocationsStartEnd, TruckDriversSnippet, LoadLocationsTooltip, LoadExpenses, LoadDocuments, LoadsReportTemplate, LoadsTotals, ReportActions, FiltersPanel },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      totalsCounts: {
        loadsCount: 0,
        totalLoadsDistance: 0,
        totalLoadsRate: 0,
        totalAvgLoadsRatePerMile: 0,
        totalAdditionalPayments: 0,
        totalLoadsExpenses: 0,
        totalLoadsGross: 0,
        totalLoadsNet: 0
      },
      loads: [],
      selectedItems: [],
      search: '',
      expensesModal: false,
      expensesModalKey: new Date().getTime(),
      selectedExpenses: [],
      selectedExpensesLoadId: 0,
      selectedExpensesTruckId: 0,
      selectedExpensesUserId: 0,
      selectedFinishedField: 0,
      documentsModal: false,
      documentsModalKey: new Date().getTime(),
      selectedELoadFields: {},
      reportsGroupsListKey: 'reportsGroupsListKey' + new Date().getTime(),
      headers: [
        { text: '#', value: 'id' },
        { text: '', value: 'status' },
        { text: 'Started/Ended', value: 'started' },
        { text: 'Locations', value: 'name' },
        { text: 'Dispatcher/Broker', value: 'disp_broker' },
        { text: 'Drivers/Trucks', value: 'drivers_trucks', sortable: false },
        { text: 'UID/Load Number', value: 'uid' },
        { text: 'Miles', value: 'miles' },
        { text: 'Rate', value: 'rate' },
        { text: 'Rate per Mile', value: 'rpm' },
        { text: 'Factoring', value: 'factoring' },
        { text: 'Gross', value: 'gross' },
        { text: 'Expenses', value: 'expenses' },
        { text: 'Net Income', value: 'net' },
        { text: '', value: 'actions', sortable: false }
      ],
      footer_props: {
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': '',
        'disable-items-per-page': false
      }
    };
  },
  computed: {
  },
  mounted () {
    this.$set(this, 'filtersItems', this.filtersItems);
    this.$root.setLastListPath(this.$route.path);
    this.$nextTick(() => {
      this.fetchData();
    });
  },
  methods: {
    clearTotals () {
      this.totalsCounts = {
        loadsCount: 0,
        totalLoadsDistance: 0,
        totalLoadsRate: 0,
        totalAvgLoadsRatePerMile: 0,
        totalAdditionalPayments: 0,
        totalLoadsExpenses: 0,
        totalLoadsGross: 0,
        totalLoadsNet: 0
      };
    },
    onItemSelected () {
      this.$nextTick(() => {
        let i = 0;
        let selected = [];
        for (i = 0; i < this.selectedItems.length; i++) {
          selected.push(parseInt(this.selectedItems[i]['id']));
        }
        this.$emit('selected', selected);
      });
    },
    onShowExpenses (expensesJSON, finishedField, loadId, trucksDrivers = []) {
      if (expensesJSON) {
        this.selectedExpensesLoadId = loadId;
        this.selectedExpenses = JSON.parse(expensesJSON);
        this.selectedFinishedField = finishedField;
        this.selectedExpensesTruckId = 0;
        this.selectedExpensesUserId = 0;
        if (trucksDrivers && trucksDrivers.length > 0) {
          this.selectedExpensesTruckId = trucksDrivers[0].id;
          if (trucksDrivers[0].drivers && trucksDrivers[0].drivers.length > 0) {
            this.selectedExpensesUserId = trucksDrivers[0].drivers[0].id;
          }
        }
        this.expensesModalKey = new Date().getTime();
        this.expensesModal = true;
      }
    },
    onShowDocuments (fields) {
      if (fields) {
        this.selectedELoadFields = fields;
        this.documentsModalKey = new Date().getTime();
        this.documentsModal = true;
      }
    },
    onFilterChanged (e) {
      let i = 0;
      let field = '';
      let value = '';
      const filtersFields = Object.keys(e);
      for (i = 0; i < filtersFields.length; i++) {
        field = filtersFields[i];
        value = Object.prototype.hasOwnProperty.call(e, field) ? e[field] : null;
        if (value !== '') {
          this[field] = Array.isArray(value) ? value.join(',') : value;
        }
      }
      if (this.isFilterInitialized) {
        this.fetchData();
      }
      this.isFilterInitialized = true;
    },
    fetchData (skipSelected = false, selected = []) {
      if (!this.from || !this.to) return;
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.getLoadsReportData(this.from, this.to).then((response) => {
          let i = 0;
          let load = null;
          let locations = null;
          if (response.status === 'ok') {
            this.clearTotals();
            this.loads = [];

            let selectedArray = [];
            if (!skipSelected && this.selectedStr) {
              selectedArray = this.selectedStr.split(',').map(v => {
                return parseInt(v);
              });
            }
            else if (!skipSelected && selected.length > 0) {
              for (let i = 0; i < selected.length; i++) {
                selectedArray.push(selected[i]);
              }
            }
            this.selectedItems = [];

            for (i = 0; i < response.loads.length; i++) {
              load = response.loads[i];
              if (selectedArray.length > 0 && selectedArray.indexOf(parseInt(load.id)) < 0) continue;

              // Check filters
              if (this.hasOwnProperty('filterDispatcher') && parseInt(this.filterDispatcher) > 0) {
                let isExists = false;
                if (this.filterDispatcher.split(',').indexOf(load.dispatcher.toString()) >= 0) {
                  isExists = true;
                }
                if (!isExists) continue;
              }
              if (this.hasOwnProperty('filterTruck') && parseInt(this.filterTruck) > 0) {
                if (load.trucks.length === 0) continue;
                let isExists = false;
                for (let fi = 0; fi < load.trucks.length; fi++) {
                  if (this.filterTruck.split(',').indexOf(load.trucks[fi].id.toString()) >= 0) {
                    isExists = true;
                    break;
                  }
                }
                if (!isExists) continue;
              }
              if (this.hasOwnProperty('filterDriver') && parseInt(this.filterDriver) > 0) {
                if (load.trucks.length === 0) continue;
                let isExists = false;
                for (let fi = 0; fi < load.trucks.length; fi++) {
                  for (let fj = 0; fj < load.trucks[fi].drivers.length; fj++) {
                    if (this.filterDriver.split(',').indexOf(load.trucks[fi].drivers[fj].id.toString()) >= 0) {
                      isExists = true;
                      break;
                    }
                  }
                  if (isExists) break;
                }
                if (!isExists) continue;
              }
              if (this.hasOwnProperty('filterBroker') && parseInt(this.filterBroker) > 0) {
                let isExists = false;
                if (this.filterBroker.split(',').indexOf(load.broker.toString()) >= 0) {
                  isExists = true;
                }
                if (!isExists) continue;
              }

              this.totalsCounts.loadsCount += 1;
              this.totalsCounts.totalLoadsDistance += parseInt(response.loads[i].distanceInMiles);
              this.totalsCounts.totalLoadsRate += parseFloat(response.loads[i].Rate) + parseFloat(response.loads[i].RTLRate || 0);
              this.totalsCounts.totalAvgLoadsRatePerMile = (this.totalsCounts.totalLoadsRate / parseFloat(this.totalsCounts.totalLoadsDistance)).round(2);
              this.totalsCounts.totalAdditionalPayments += parseFloat(load.additionalPayments);
              // this.totalsCounts.totalLoadsRateWithAdditionalPayments += parseFloat(response.loads[i].Rate) + parseFloat(load.additionalPayments);
              this.totalsCounts.totalLoadsGross += parseFloat(response.loads[i].gross);
              this.totalsCounts.totalLoadsExpenses += parseFloat(response.loads[i].expenses);
              this.totalsCounts.totalLoadsNet += parseFloat(response.loads[i].net);

              // this.totalsCounts.totalDrivers = Object.assign(this.totalsCounts.totalDrivers, response.loads[i].drivers);
              // this.totalsCounts.totalTrucks = Object.assign(this.totalsCounts.totalTrucks, response.loads[i].trucks);

              // locations = JSON.parse(response.loads[i].locationsJSON.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t'));
              locations = response.loads[i].locations;
              load.locations = locations;
              load.status = this.$root.getLoadStatus(locations, response.loads[i].finished);

              let pickupLocationName = 'N/A';
              let deliveryLocationName = 'N/A';
              for (let j = 1; j < load.locations.length; j++) {
                if (load.locations[j].pickup === 1) {
                  pickupLocationName = load.locations[j].name;
                  break;
                }
              }
              for (let j = load.locations.length - 1; j > 0; j--) {
                if (load.locations[j].delivery === 1) {
                  deliveryLocationName = load.locations[j].name;
                  break;
                }
              }
              pickupLocationName = pickupLocationName.replace(/, USA/gi, '');
              if (pickupLocationName.split(',').length > 2) {
                pickupLocationName = pickupLocationName.substring(pickupLocationName.indexOf(',') + 1);
              }
              deliveryLocationName = deliveryLocationName.replace(/, USA/gi, '');
              if (deliveryLocationName.split(',').length > 2) {
                deliveryLocationName = deliveryLocationName.substring(deliveryLocationName.indexOf(',') + 1);
              }
              // Process load item
              load.uid_load_number = load.loadNumber + ' ' + load.uid;

              load.pickupLocationName = pickupLocationName;
              load.deliveryLocationName = deliveryLocationName;
              load.name = pickupLocationName + ' -- ' + deliveryLocationName;
              load.rate = load.Rate.toFixed(2);
              load.miles = load.distanceInMiles;
              load.rpm = parseFloat(load.rate) / parseFloat(load.miles);
              load.factoring = parseFloat(load.factoringPercent).toFixed(2);
              load.expenses = parseFloat(response.loads[i].expenses).toFixed(2);

              this.loads.push(load);
            }
          }
          this.reportsGroupsListKey = 'reportsGroupsListKey' + new Date().getTime();
          this.$forceUpdate();
          this.onItemSelected();
          this.loading = false;
          this.initReportsFilters();
          resolve(this.totalsCounts);
        }).finally(() => {
          this.loading = false;
        });
      });
    }
  }
};
</script>
